import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
/** withRouter must be here @see: https://github.com/ReactTraining/react-router/issues/4671 */
import { withRouter } from 'react-router-dom'

import { pathname } from 'store/entities/router/selectors'
import {
  getIdentityFirstLogin,
  isStageIsSelection,
  getIdentityFirstLoginFlow,
  getIdentityActiveProTrackId,
  isIdentityActiveProTrackAutoEnroll,
} from 'store/entities/identity/selectors'
import { isTranslationsLoadedForDashboardPage } from 'store/entities/organizationSettings/selectors'
import UserRouter from './UserRouter'

const mapStateToProps = createStructuredSelector({
  pathname,
  isFirstLogin: getIdentityFirstLogin,
  isStageIsSelection,
  isLoginFlowFinished: getIdentityFirstLoginFlow,
  activeLevelId: getIdentityActiveProTrackId,
  isAutoEnroll: isIdentityActiveProTrackAutoEnroll,
  isTranslationsLoadedForDashboardPage,
})

/** withRouter must be here @see: https://github.com/ReactTraining/react-router/issues/4671 */
export default withRouter(connect(mapStateToProps)(UserRouter))
